import instance from './instance'

const productUrl = 'modules-coupon/products'

export const getProductList = (page: number, pageSize: number, filterKey: any) =>
  instance.get(`${productUrl}?page=${page}&pageSize=${pageSize}&filterkey=${filterKey}`)

export const getProductById = (id: number) => instance.get(`${productUrl}/${id}`)

export const createProduct = (payload: any) => instance.post(`${productUrl}`, payload)

export const updateProduct = (id: any, payload: any) => instance.post(`${productUrl}/${id}`, payload)

export const deleteProduct = async (id: number) => await instance.delete(`${productUrl}/${id}`)
